import { tempMeeApi } from '~/services/api';
import type { ISendOtpApiPayload, TSendOtpApiResponse } from '../types/ForgotPassword.api';

export const sendOtp = async (payload: ISendOtpApiPayload): Promise<TSendOtpApiResponse> => {
  const { data } = await tempMeeApi.post<TSendOtpApiResponse>('/auth-service/otp', payload);
  return data;
};
